import { reducer as templatesReducer } from '@sunwisesoftware/racking-template-core';
import { connectRouter } from 'connected-react-router';
import { combineReducers } from 'redux';
import { reducer as formReducer } from 'redux-form';

import alerts from 'common/modules/alerts';
import productDatasheet from 'common/modules/productDatasheet';
import productThumbnail from 'common/modules/productThumbnail';

import attachments from './modules/attachments';
import companies from './modules/companies';
import companyGeneral from './modules/companyGeneral';
import companyUsers from './modules/companyUsers';
import createAttachmentModal from './modules/createAttachmentModal';
import createTemplateModal from './modules/createTemplateModal';
import editTemplateView from './modules/editTemplateView';
import login from './modules/login';
import multiTemplateReview from './modules/multiTemplateReview';
import parametersPanels from './modules/parametersPanels';
import parametersWinds from './modules/parametersWinds';
import products from './modules/products';
import profile from './modules/profile';
import profileSecurity from './modules/profileSecurity';
import proposals from './modules/proposals';
import systems from './modules/systems';
import templates from './modules/templates';

export default (history) =>
    combineReducers({
        [alerts.NAME]: alerts.reducer,
        [attachments.NAME]: attachments.reducer,
        [companies.NAME]: companies.reducer,
        [companyGeneral.NAME]: companyGeneral.reducer,
        [companyUsers.NAME]: companyUsers.reducer,
        [createAttachmentModal.NAME]: createAttachmentModal.reducer,
        [createTemplateModal.NAME]: createTemplateModal.reducer,
        [editTemplateView.NAME]: editTemplateView.reducer,
        [login.NAME]: login.reducer,
        [multiTemplateReview.NAME]: multiTemplateReview.reducer,
        [parametersPanels.NAME]: parametersPanels.reducer,
        [parametersWinds.NAME]: parametersWinds.reducer,
        [products.NAME]: products.reducer,
        [productDatasheet.NAME]: productDatasheet.reducer,
        [products.NAME]: products.reducer,
        [productThumbnail.NAME]: productThumbnail.reducer,
        [profile.NAME]: profile.reducer,
        [profileSecurity.NAME]: profileSecurity.reducer,
        [proposals.NAME]: proposals.reducer,
        [systems.NAME]: systems.reducer,
        [templates.NAME]: templates.reducer,
        form: formReducer,
        router: connectRouter(history),
        sunwiseTemplateCore: templatesReducer,
    });
